define(function() {
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
        	urlRoot: '/delegate/civics-api/api/portal/configuration',
			url:function(){
				return this.urlRoot;
			},
		parse: function(response) {
			const data = response.data || {};
			
			data.mfaEnforced = data.mfaRequired && data.mfaEnabled;

			return data;
        }
	});
});
